import React, {useState} from 'react';
import PropTypes from 'prop-types';
import styles from '../../../SearchWidget.module.scss';
import switcherPath from '../../../../../assets/media/switcherIcon.svg';
import animations from '../../../../../assets/scss/animations/animate.module.scss';


const AirportsSwitcher = ({disabled, clickHandler, animated}) => {

    const [animationClasses, setAnimationClasses] = useState('');

    const classes = [styles.airportsSelectorSwitcherContainer];
    if (disabled) classes.push(styles.airportsSelectorSwitcherDisabled);
    if (animated) classes.push(animationClasses);

    const onClickHandler = (e) => {
        if (disabled) return e;

        setAnimationClasses(`${animations.animated} ${animations.touchEffect}`);
        setTimeout(() => setAnimationClasses(''), 500);
        return clickHandler(e);
    };

    return (
        <div onClick={onClickHandler} className={classes.join(' ')}>
            <img src={switcherPath} alt={'switcher'}/>
        </div>
    );
};

AirportsSwitcher.propTypes = {
    clickHandler: PropTypes.func,
    disabled: PropTypes.bool,
    animated: PropTypes.bool,
};

AirportsSwitcher.defaultProps = {
    clickHandler: () => null,
    disabled: false,
    animated: false,
};

export default AirportsSwitcher;
